require('./CancelChoreConfirmation.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
const moment = require('moment');

// @ utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const { formatCurrency, getFormattedString } = require('utilities/currencyHelper');

// @ components
const WizardError = require('components/commons/wizardError/wizardError');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { ContentBox } = require('commonsComponents/contentBox');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @ constants
const { OPENYOUNG_CHORE_CANCEL, DATE_FORMAT_DAY_MONTH_SHORT, EURO_TEXT } = require('constants/index');

class CancelChore extends React.Component {
    constructor(props) {
        super(props);
        this.handleCancelChoreClick = this.handleCancelChoreClick.bind(this);
        this.handleCancelConfirmation = this.handleCancelConfirmation.bind(this);
        this.createList = this.createList.bind(this);
        this.isReady = this.isReady.bind(this);
    }

    handleCancelConfirmation() {
        const { cardId } = this.props.match.params;
        this.props.history.push(`/myprofile/cards/${cardId}/chores`);
    }

    handleCancelChoreClick() {
        const { openYoungCardChores, match: { params: { choreAssignmentId } }, updateChoreStatus } = this.props;
        const choreDetail = openYoungCardChores.get('choreDetail');
        const choreStatusDetails = {
            choreAssignmentId: choreAssignmentId,
            confirmationComment: '',
            choreStatusId: OPENYOUNG_CHORE_CANCEL,
            reward: choreDetail.get('reward',0)
        };
        updateChoreStatus(choreStatusDetails);
    }

    isReady() {
        return false;
    }

    buildErrorWizard(immCard) {
        const cardAlias = immCard.get('alias').get('current');
        const goBackButtonLabel = formatText('cancelChore-backToCard', [cardAlias]).toUpperCase();
        const cardId = immCard.get('cardId');
        const linkToDetails = `/myprofile/cards/${cardId}/movements`;
        const mainButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        };
        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <WizardError
                    errorMessage={formatText('cancelChore-errorTitle')}
                    mainButton={mainButton}
                >
                    <div className="cancel-chore-confirmation__error-body">
                        <p className="col-md-6">
                            <CommercialAds path="cards" type="cards" immCard={immCard} size="medium"/>
                        </p>
                        <p className="cancel-chore-confirmation__error-sub-message col-md-6">
                            <FormattedText
                                value="cancelChore-errorBodyText"
                            />
                        </p>
                    </div>
                </WizardError>
            </div>
        );
    }

    buildSuccessWizard(immCard) {
        const { openYoungCardChores } = this.props;
        const choreDetail = openYoungCardChores.get('choreDetail');
        const nameOfTask = formatText(`openYoungCardChores-task${choreDetail.getIn(['chore','choreId'])}`);
        const cardAlias = immCard.get('alias').get('current');
        const goBackButtonLabel = formatText('cancelChore-backToCard', [cardAlias]).toUpperCase();
        const cardId = immCard.get('cardId');
        const linkToDetails = `/myprofile/cards/${cardId}/movements`;
        const mainButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        };
        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <WizardSuccess
                    successMessage={formatText('cancelChore-successTitle')}
                    mainButton={mainButton}
                >
                    <div className="cancel-chore-confirmation__success-body">
                        <div className="col-md-6">
                            <CommercialAds path="cards" type="cards" immCard={immCard} size="medium"/>
                        </div>
                        <p className="cancel-chore-confirmation__success-sub-message col-md-6">
                            <FormattedText
                                value="cancelChore-successBodyText"
                                injectedStrings={[nameOfTask]}
                            />
                        </p>
                    </div>
                </WizardSuccess>
            </div>
        );
    }

    createList(list){
        return  list.map((item, key) => {
            if(item.value && item.value!= " "){
                return(
                    <OKInformativeListItem
                        className={"cancel-chore-confirmation__list-item"}
                        key={key}
                        title={item.label}
                        bodyText={item.value}
                        bodyWordBreak={false}
                    />
                )
            }
        });
    }

    render() {
        const {
            immCards,
            openYoungCardChores,
            openYoungCardChoreStatusUpdateInfo,
            match: { params: { cardId } }
        } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        const contentTitle = formatText('cancelChore-contentTitle');
        const immChoreDetails = openYoungCardChores.get('choreDetail');
        const currency = formatCurrency(EURO_TEXT);
        const reward = getFormattedString({ amount: immChoreDetails.get('reward'), currency });
        let block;

        const items = [
            {
                label: formatText('cancelChore-chore'),
                value: formatText(`openYoungCardChores-task${immChoreDetails.getIn(['chore','choreId'])}`)
            },
            {
                label: formatText('cancelChore-status'),
                value: formatText(`openYoungCardChores-status${immChoreDetails.getIn(['choreStatus','choreStatusId'])}`)
            },
            {
                label: formatText('cancelChore-selectedEndDate'),
                value: moment(immChoreDetails.get('endDate')).format(DATE_FORMAT_DAY_MONTH_SHORT)
            },
            {
                label: formatText('cancelChore-amount'),
                value: reward
            },
            {
                label: formatText('cancelChore-repetitions'),
                value: immChoreDetails.get('repeatTask') || 'No repetir'
            },
            {
                label: formatText('cancelChore-concept'),
                value: immChoreDetails.getIn(['comments','choreAssignmentComment'])
            },
            {
                label: formatText('cancelChore-childComment'),
                value: immChoreDetails.getIn(['comments','childComment'])
            },
            {
                label: formatText('cancelChore-choreConfirmationComment'),
                value: immChoreDetails.getIn(['comments','choreConfirmationComment'])
            }
        ];

        if (openYoungCardChoreStatusUpdateInfo && openYoungCardChoreStatusUpdateInfo.get('submitSuccessful')) {
            block = this.buildSuccessWizard(immCard);
        } else if (openYoungCardChoreStatusUpdateInfo && openYoungCardChoreStatusUpdateInfo.get('submitError')) {
            block = this.buildErrorWizard(immCard);
        } else {
            const acceptText = formatText('wizard-redirectConfirmationAcceptButton');
            const cancelText = formatText('wizard-redirectConfirmationCancelButton');
            const confirmationTitle = formatText('wizard-redirectConfirmationTitle');
            const confirmationMessage = formatText('wizard-redirectConfirmationMessage');

            block = (
                <ContentBox id="cancelChore" smallTitle={true} title={contentTitle}>
                    <div>
                        <PreLeaveModalComponent
                            acceptText={acceptText}
                            confirmationMessage={confirmationMessage}
                            confirmationTitle={confirmationTitle}
                            cancelText={cancelText}
                            isReady={this.isReady}
                        />

                        <OKInformativeList columns={3}>
                            {this.createList(items)}
                        </OKInformativeList>

                        <div className="cancel-chore-confirmation__separator"/>
                        <footer className="cancel-chore-confirmation__button text-right">
                            <div className="pull-left">
                                <OKButton modifier="link-ghost" onClick={this.handleCancelConfirmation}>
                                    <FormattedText value="common-cancel" />
                                </OKButton>
                            </div>
                            <OKButton
                                onClick={this.handleCancelChoreClick}
                                loading={openYoungCardChoreStatusUpdateInfo.get('isFetching')}
                            >
                                <FormattedText value="cancelChore-confirmButtonText"/>
                            </OKButton>
                        </footer>
                    </div>
                </ContentBox>
            );
        }

        return block;
    }
}

CancelChore.propTypes = {
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    openYoungCardChoreStatusUpdateInfo: PropTypes.object.isRequired,
    openYoungCardChores: PropTypes.object.isRequired,
    match: PropTypes.object,
    updateChoreStatus: PropTypes.func.isRequired
};

module.exports = withRouter(CancelChore);
